var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardLogoRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 50,
    viewBox: "0 0 104 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2136:5921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6666 25.625H28.186L32.2394 0.456299H38.7197L34.6666 25.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1592 1.07153C56.8809 0.562278 54.8535 0 52.3466 0C45.9468 0 41.4402 3.42705 41.4125 8.32669C41.3594 11.9416 44.6392 13.9495 47.0922 15.1548C49.5994 16.3865 50.4517 17.1904 50.4517 18.2883C50.4262 19.9744 48.4257 20.7516 46.5599 20.7516C43.9726 20.7516 42.5862 20.3509 40.4795 19.4128L39.6261 19.0107L38.7192 24.6605C40.2392 25.3559 43.0395 25.973 45.9468 26C52.7467 26 57.1736 22.626 57.2261 17.4046C57.252 14.5395 55.5201 12.3441 51.7863 10.5502C49.5197 9.39858 48.1316 8.62207 48.1316 7.44378C48.1582 6.3726 49.3057 5.27545 51.8643 5.27545C53.9711 5.22171 55.519 5.73025 56.6917 6.23915L57.2778 6.50641L58.1592 1.07153V1.07153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7726 16.7086C67.3063 15.2627 69.3599 9.66662 69.3599 9.66662C69.333 9.72036 69.8926 8.19402 70.2126 7.25701L70.6655 9.4257C70.6655 9.4257 71.8927 15.4503 72.1592 16.7086C71.1464 16.7086 68.0526 16.7086 66.7726 16.7086ZM74.772 0.456299H69.7593C68.2135 0.456299 67.0391 0.911103 66.3721 2.54456L56.7461 25.6246H63.5459C63.5459 25.6246 64.6654 22.5182 64.9061 21.8492C65.652 21.8492 72.2669 21.8492 73.2266 21.8492C73.4126 22.7328 73.9998 25.6246 73.9998 25.6246H80.0002L74.772 0.456299V0.456299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7731 0.456299L16.4265 17.6189L15.733 14.1382C14.5596 10.1218 10.8798 5.75808 6.77319 3.58833L12.5865 25.5983H19.4395L29.6258 0.456299H22.7731V0.456299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5333 0.456299H0.106668L0 0.96484C8.13339 3.05345 13.52 8.08797 15.7331 14.1392L13.4665 2.57196C13.0933 0.964484 11.9465 0.509324 10.5333 0.456299Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2136:5921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 50,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLogoRight);
export default __webpack_public_path__ + "static/media/card-logo-right.f787ed087d0ddc2bcb7dba54927ede90.svg";
export { ForwardRef as ReactComponent };